// The values the store's `gst_applicable` column holds (it may also be null).
export const GST_APPLIED = "GST Applied";
export const GST_NOT_APPLICABLE = "Not Applicable";
